<app-popin popinTitle="dashboard_report.move_widgets">
  <div content>
    <div [@showOpacity]="'show'" class="opacity-0">
      <gridster [options]="options">
        <gridster-item *ngFor="let w of dashboard"
                       [item]="w">
          {{ w.config.title }}
        </gridster-item>
      </gridster>
    </div>
  </div>
  <div actions>
    <app-button buttonType="mat-button"
                (onClick)="dialogRef.close()">{{ 'button.close' | translate }}</app-button>
    <app-button icon="done"
                buttonType="mat-raised-button"
                (onClick)="onSubmit()">{{ 'button.apply' | translate }}</app-button>
  </div>
</app-popin>
